// extracted by mini-css-extract-plugin
module.exports = {"c1avqesr":"c1avqesr","tcp2hl6":"tcp2hl6"};